<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-clipboard-check
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      :title="position.name"
      text="Edit Position Approval Settings"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="module"
                :items="modules"
                item-text="value"
                item-value="module"
                label="Module"
              />

              <setup-positions-approvals-leave-container-view
                v-if="module==='leave'"
                :position="position"
                @close-dialog="closeDialog"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      SetupPositionsApprovalsLeaveContainerView: () => import('@/components/setup/positions/approvals/LeaveContainerView'),
    },
    inject: ['$validator'],
    props: {
      position: { 
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        leaveTypes: [],
        module: 'leave',
        modules: [
          { module: 'leave', value: 'Leave' },
        ],
      }
    },
    watch: {
      dialog: function (value) {
        // if (value) {
        //   this.loadData()
        // } else {
        //   this.$resetData()
        // }
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
      },
      
    },
  }
</script>
